export default __webpack_public_path__ + "static/media/user-icon.7e344616.svg";